module.exports = __webpack_public_path__ + "img/slovak_forum.0491c56b.png";